import { SET_SELECTED_ORDER_CARRIER } from './OrderActionTypes';
import type { IDeliveryCarrier } from '@model/DeliveryAddress.model';

export const setSelectedCarrierAction = (carrier: IDeliveryCarrier | null) => (dispatch: any) => {
  dispatch({
    type: SET_SELECTED_ORDER_CARRIER,
    payload: { carrier: carrier ?? null },
  });
};
